module.exports = __webpack_public_path__ + "static/media/Profile@2x.380d3429.jpg";